import type { ScheduleCData } from '@/api/hooks/useScheduleC';

export function PreparerCalculationsCard({ lines }: { lines: ScheduleCData['lines'] }) {
  const required = lines.filter((line) => line.preparer_required);
  if (required.length === 0) return null;
  return (
    <section className="mt-4 rounded-[10px] border border-warning bg-warning/10 p-4" aria-labelledby="preparer-calculations-heading">
      <h2 id="preparer-calculations-heading" className="font-semibold text-warning-foreground">Preparer calculations · {required.length} lines</h2>
      <div className="mt-2 space-y-2 text-sm text-foreground">{required.map((line) => <div key={line.tax_line}><strong>{line.tax_line} {line.label}</strong> — {line.preparer_reason ?? 'Preparer calculation required.'}{line.preparer_facts?.length ? <ul className="ml-4 list-disc text-xs text-muted-foreground">{line.preparer_facts.map((fact) => <li key={fact}>{fact}</li>)}</ul> : null}</div>)}</div>
      <p className="mt-3 text-xs text-muted-foreground">These export as preparer inputs with facts and blanks, never a computed number.</p>
    </section>
  );
}

export default PreparerCalculationsCard;
